/* Trusted Shops card widgets: stamp <template class="ck-gt-ts-lazy"> when its card nears the viewport. */
(function () {
  if (window.__ckTsLazyInit) return;
  window.__ckTsLazyInit = true;
  var stamp = function (tpl) { if (tpl.content) tpl.replaceWith(tpl.content); else tpl.outerHTML = tpl.innerHTML; };
  var all = function () { document.querySelectorAll('template.ck-gt-ts-lazy').forEach(stamp); };
  if (!('IntersectionObserver' in window)) { all(); return; }
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (!e.isIntersecting) return;
      io.unobserve(e.target);
      e.target.querySelectorAll('template.ck-gt-ts-lazy').forEach(stamp);
    });
  }, { rootMargin: '400px 0px' });
  var watch = function (tpl) { var host = tpl.parentElement; if (host) io.observe(host); };
  var observe = function (root) { (root.querySelectorAll ? root.querySelectorAll('template.ck-gt-ts-lazy') : []).forEach(watch); };
  observe(document);
  new MutationObserver(function (muts) {
    muts.forEach(function (m) { m.addedNodes.forEach(function (n) { if (n.nodeType !== 1) return; if (n.matches && n.matches('template.ck-gt-ts-lazy')) watch(n); else observe(n); }); });
  }).observe(document.documentElement, { childList: true, subtree: true });
})();
